module.exports = __webpack_public_path__ + "static/media/whatsapp.bb1b2eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/components/screens/horoscopes/whatsapp.png
// module id = 363
// module chunks = 0